import NumberUtils from '../primitives/NumberUtils';
export default class MathUtils {
    static approxEquals(val1, val2, epsilon) {
        if (val1 === undefined || val2 === undefined) {
            return val1 === val2;
        }
        return Math.abs(val1 - val2) <= epsilon;
    }
    static div(dividend, divisor) {
        return NumberUtils.ensureValid(dividend / divisor);
    }
    static ensureInRange(value, min, max) {
        if (!NumberUtils.isNumber(value)) {
            return undefined;
        }
        else if (value < min) {
            return min;
        }
        else if (value > max) {
            return max;
        }
        else {
            return value;
        }
    }
    static ensurePositive(value, valueIfNegative = undefined) {
        if (!NumberUtils.isNumber(value)) {
            return undefined;
        }
        else if (value < 0) {
            return valueIfNegative;
        }
        else {
            return value;
        }
    }
    static floor(value, precision = 0) {
        if (value == undefined || isNaN(value)) {
            return undefined;
        }
        else if (precision == 0) {
            return Math.floor(value);
        }
        else {
            return Math.floor(value / precision) * precision;
        }
    }
    static isBetween(value, min, max) {
        return value >= min && value <= max;
    }
    static map(percent, min, max) {
        return min + (max - min) * percent;
    }
    static max(...values) {
        let maxValue;
        values.forEach(value => {
            if (value !== undefined && (maxValue === undefined || value > maxValue)) {
                maxValue = value;
            }
        });
        return maxValue;
    }
    static min(...values) {
        let minValue;
        values.forEach(value => {
            if (value !== undefined && (minValue === undefined || value < minValue)) {
                minValue = value;
            }
        });
        return minValue;
    }
    static percent(value, length) {
        return Number.ensureValid(value / length * 100);
    }
    static percentile(orderedValues, percentile) {
        if (percentile < 0 || percentile > 1) {
            throw new RangeError('Percentile value must be between within the range [0, 1].');
        }
        else if (orderedValues.length === 0) {
            return undefined;
        }
        const index = Math.round(orderedValues.length * percentile) - 1;
        if (index < 0) {
            return undefined;
        }
        return orderedValues[index];
    }
    static rescale(value, fromStart, fromEnd, toStart, toEnd) {
        if (fromStart === fromEnd) {
            return toEnd;
        }
        return toStart + ((value - fromStart) / (fromEnd - fromStart) * (toEnd - toStart));
    }
    static reversePercentile(orderedValues, value) {
        for (let i = orderedValues.length - 1; i >= 0; i--) {
            if (orderedValues[i] < value) {
                if ((i + 2) > orderedValues.length) {
                    return 1;
                }
                else {
                    return (i + 2) / orderedValues.length;
                }
            }
        }
        return 0;
    }
    static round(value, precision = 0) {
        if (value === undefined || isNaN(value)) {
            return undefined;
        }
        else if (precision === 0) {
            return Math.round(value);
        }
        else {
            return Math.round((value) * Math.pow(10, precision)) / Math.pow(10, precision);
        }
    }
    static roundToNearest(value, nearest) {
        if (value === undefined) {
            return undefined;
        }
        return Math.round(value / nearest) * nearest;
    }
    static wrap(value, min, max) {
        const rangeSize = max - min + 1;
        if (value < min) {
            value += rangeSize * ((min - value) / rangeSize + 1);
        }
        return min + (value - min) % rangeSize;
    }
}
//# sourceMappingURL=MathUtils.js.map